.root {
  /* stylelint-disable-next-line @prtimes-frontend/no-font-family-in-css-modules */
  font-family: var(--font-family);
}

.pc {
  min-width: 1250px;
}
